import React from "react"
import JobDescription from "components/JobDescription"
import ListItem from "components/ListItem"

const heroDescription = `Vi söker just nu efter en driven back end-utvecklare
till vårt team i Uppsala. Vi söker någon som brinner för programmering och som
har en vilja att bli bäst tillsammans med oss! Det viktigaste för oss är inte
dina tidigare erfarenheter utan att du har en vilja att lära dig och en vilja att bli bättre.`

const experiences = [
  "Erfarenhet inom back end-arkitektur",
  "Erfarenhet av TypeScript är meriterande",
  "Minst två års erfarenhet av back end-utveckling",
  "Erfarenhet av Ruby, Node.js och .NET är meriterande",
  "Erfarenhet inom agila metoder som Scrum och Kanban",
  "Du har sysslat med lagidrott eller någon form av lagspel, t.ex. någon e-sport",
  "Erfarenhet inom designmönster och kunskap att skriva lätthanterlig, läsbar och effektiv kod",
]

const BackEndDeveloper = () => (
  <JobDescription
    position="Back end-utvecklare"
    location="Uppsala"
    heroDescription={heroDescription}
    previousExperiences={experiences}
    renderJobDescription={() => (
      <React.Fragment>
        <b>Ditt arbete inkluderar</b>
        <ul>
          <ListItem text="Back end-utveckling åt både kunder och för våra egna interna projekt" />
          <ListItem
            text="Att arbeta i agila utvecklingsprocesser som inkluderar kod,
            kodgranskning veckomöten samt kundmöten"
          />
          <ListItem
            text="Att vara en del av vårt lag där
            vi tillsammans hjälper varandra att utvecklas och bli bättre"
          />
        </ul>
      </React.Fragment>
    )}
    renderWeOffer={() => (
      <React.Fragment>
        <b>Vi erbjuder</b>
        <p>
          En trevlig och lättsam arbetsplats där alla ger sitt yttersta för att
          leverera det bästa möjliga till våra kunder och samtidigt utveckla sig
          själva. Du kommer att få ett stort ansvar redan från start och
          stöttning av resterande teamet under alla dina projekt.
        </p>
      </React.Fragment>
    )}
    renderBenefits={() => (
      <React.Fragment>
        <b>Förmåner</b>
        <ul>
          <ListItem text="Gymkort" />
          <ListItem text="Tjänstepension" />
          <ListItem text="Sjukvårdsförsäkring" />
          <ListItem text="Olycksfallsförsäkring" />
          <ListItem text="Fria arbetstider" />
        </ul>
      </React.Fragment>
    )}
  />
)

export default BackEndDeveloper



// WEBPACK FOOTER //
// ./src/pages/JobDescriptions/BackEndDeveloper/index.jsx